import { useDefaultPositionsTabs } from '../../../Blotters/PositionsV3/defaults';
import type { PositionsTabProps } from '../../../Blotters/PositionsV3/types';
import { MobileBlotterPanel, type MobileBlotterPanelProps } from './MobileBlotterPanel';

/** Placeholder-only mobile positions content; uses `TradingPlaceholder` via `MobileBlotterPanel`. */
export function MobilePositionsBlotter(props: Omit<MobileBlotterPanelProps<PositionsTabProps>, 'defaultTabs'>) {
  const defaultTabs = useDefaultPositionsTabs();
  return <MobileBlotterPanel<PositionsTabProps> {...props} defaultTabs={defaultTabs} />;
}
